import { render } from "./ChatWindow.vue?vue&type=template&id=517e432f"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"
script.render = render

export default script